import React, { useState } from 'react';
import { Trans } from "react-i18next";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';


const MainCard = ({ title, children, linkTo, titleLink, linkColor, titleColor, threeDots=true, history, dropDownItems, hr, fsize }) => {

    const [showDrop, setDrop] = useState(false);

    const pushToLink = () => history.push(titleLink)
    
    return (

    <div style={{
      padding: "25px", 
      border: "1px solid #ddd",
      borderRadius: "8px",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", 
      backgroundColor: "#fff",
      height:"100%",
      textAlign:"center"
    }}>
        {linkTo && (
            <div>
                <a className="float-right btn btn-primary btn-sm d-print-none" href={linkTo}>
                    <Trans>Open Report</Trans>
                </a>
            </div>
        )}
        <div className='d-flex justify-content-start align-items-center pb-2'>
        <h3 className='my-0'>
            {titleLink ? (
                <a
                onClick={() => pushToLink()}
                onMouseOver={(e) => e.target.style.color = linkColor || '#737D85'}
                onMouseOut={(e) => e.target.style.color = titleColor || 'inherit'}
                rel="noopener noreferrer"
                style={{
                    color: 'inherit',
                    textDecoration: 'none',
                    transition: 'color 0.4s',
                    cursor: 'pointer',
                    fontSize: fsize,
                }}
                >
                    {title}
                </a>
            ) : (
            !linkTo && title
            )} 
        </h3>{threeDots && !linkTo &&<><div className='mx-auto' /><div style={{cursor:"pointer", width:20}} onClick={() => setDrop(!showDrop)}><i className="fas fa-ellipsis-v clickable"/></div></>}

        {threeDots && !linkTo &&
            <Dropdown isOpen={showDrop} toggle={() => setDrop(!showDrop)} nav>
                {/* <DropdownToggle><i className="fas fa-ellipsis-v clickable"/></DropdownToggle> */}
                <DropdownToggle nav></DropdownToggle>
                <DropdownMenu>
                    {!hr && <DropdownItem onClick={() => pushToLink()}><Trans>Expand</Trans></DropdownItem>}
                    {dropDownItems?.map((item, index) => (
                        <DropdownItem key={index} onClick={() => item.onClick()}>
                        <Trans>{item.label}</Trans>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        }
        </div>
        {!linkTo && <hr className='my-2'/>}
        {children} 
    </div>
    )};
  

  export default MainCard;